/**
 * Fensterkoordinaten für den Erklärkasten am Info-Symbol (KpiInfo).
 *
 * Anlass (Marie, 16.09.2026): Der Kasten wurde in der Kachel gezeichnet und
 * verschwand auf der Wirtschaftlichkeits-Seite zur Hälfte hinter der
 * Nachbarkachel. Seitdem liegt er auf einer eigenen Ebene über der Seite und
 * braucht feste Koordinaten: unter dem Symbol, nach oben geklappt, wenn unten
 * kein Platz ist, und immer mit Abstand zum Fensterrand.
 *
 * Bewusst ohne React — die Unit-Tests laufen auf GitHub vor der UI-Installation.
 */

export interface Rechteck {
  top: number;
  bottom: number;
  left: number;
  right: number;
}

export interface Groesse {
  breite: number;
  hoehe: number;
}

/** Abstand zwischen Symbol und Kasten. */
const ABSTAND = 4;
/** Mindestabstand des Kastens zum Fensterrand. */
const RAND = 8;

export function berechnePopoverPosition(
  anker: Rechteck,
  box: Groesse,
  fenster: Groesse,
): { top: number; left: number } {
  const unten = anker.bottom + ABSTAND;
  const oben = anker.top - ABSTAND - box.hoehe;

  let top: number;
  if (unten + box.hoehe <= fenster.hoehe - RAND) {
    top = unten;
  } else if (oben >= RAND) {
    top = oben;
  } else {
    top = Math.max(RAND, fenster.hoehe - RAND - box.hoehe);
  }

  const left = Math.max(RAND, Math.min(anker.left, fenster.breite - RAND - box.breite));
  return { top, left };
}
